export default __webpack_public_path__ + "static/media/typearrow.c383f7f3.svg";